export default "__VITE_ASSET__eGfSYHuA__"